import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Log } from '../../../models/log.model';

@Component({
    selector: 'app-log-list-item',
    templateUrl: './log-list-item.component.html',
    styleUrls: ['./log-list-item.component.scss'],
    standalone: false
})
export class LogListItemComponent {
    @Input() log: Log;

    /** Whether this component is embedded in a master-detail layout */
    @Input() embedded: boolean = false;

    /** Whether this log is currently selected */
    @Input() isSelected: boolean = false;

    /** Emits when a log is selected in embedded mode */
    @Output() logSelected = new EventEmitter<number>();

    public get isConcept(): boolean {
        return this.log?.status === 'CONCEPT';
    }

    /**
     * Get the show's primary color for the accent border.
     * Falls back to null if not set.
     */
    public get accentColor(): string | null {
        return this.log?.performance?.show?.primaryColor || null;
    }

    /**
     * Get the name of the toneelmeester.
     */
    public get toneelmeesterName(): string | null {
        if (this.log?.toneelmeester) {
            const { firstName, lastName } = this.log.toneelmeester;
            return `${firstName || ''} ${lastName || ''}`.trim() || null;
        }
        return null;
    }

    /**
     * Handle click on the log item.
     * In embedded mode, emits the selection event. Otherwise, navigation is handled by routerLink.
     */
    onItemClick(): void {
        if (this.embedded && this.log?.id) {
            this.logSelected.emit(this.log.id);
        }
    }
}
